import { StackScreenProps } from "@react-navigation/stack";
import { RegisterRootParamList } from "../../../../types";
import { Button, Page, Stack } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import { View } from "react-native-ui-lib";
import Customer from "../../../../utilities/data/model/Customer";
import {
  useAddCustomerToSale,
  useSaleControllerProvider,
} from "../../utils/sale-controller";
import { Q } from "@nozbe/watermelondb";
import {
  CustomerCard,
  CustomerCardRenderer,
} from "../../components/CustomerCard";

export type ConfirmAddScannedCustomerModalScreenProps = StackScreenProps<
  RegisterRootParamList,
  "ConfirmAddScannedCustomerModalScreen"
>;

export const ConfirmAddScannedCustomerModalScreen = (
  props: ConfirmAddScannedCustomerModalScreenProps
) => {
  const { sale } = useSaleControllerProvider();

  const { parkSaleAndAddCustomer, addCustomerAndMakeSaleByCustomerId } =
    useAddCustomerToSale({
      navigation: props.navigation,
    });

  const { t } = useTranslation("pos");
  const [customer, setCustomer] = React.useState<Customer | undefined>(
    undefined
  );
  const database = useDatabase();
  const { customerId } = props.route.params;

  React.useEffect(() => {
    database.collections
      .get<Customer>("customers")
      .query(Q.where("retailer_id", Q.eq(customerId)))
      .fetch()
      .then((matchingCustomers) => {
        if (matchingCustomers.length > 0) {
          setCustomer(matchingCustomers[0]);
        }
      })
      .catch(console.log);
  }, []);

  const handleOnAddExistingSaleOrNoSale = async () => {
    if (customer) {
      return addCustomerAndMakeSaleByCustomerId(customer.id)
        .then(() => {
          props.navigation.goBack();
        })
        .catch(console.log);
    }
  };

  const handleOnParkSaleAndAddCustomer = async () => {
    if (sale && customer) {
      return parkSaleAndAddCustomer(customer.id)
        .then(() => {
          props.navigation.goBack();
        })
        .catch(console.log);
    }
  };

  if (!customer) {
    return <View />;
  }

  const buttons = [];

  if (sale) {
    buttons.push({
      key: "add_existing_sale",
      label: "Add existing sale",
      onPress: handleOnAddExistingSaleOrNoSale,
    });
    buttons.push({
      key: "start_new_sale",
      label: "Start new sale",
      onPress: handleOnParkSaleAndAddCustomer,
    });
  } else if (!sale) {
    buttons.push({
      key: "start_new_sale",
      label: "Start new sale",
      isAction: true,
      onPress: handleOnAddExistingSaleOrNoSale,
    });
    buttons.push({
      key: "cancel",
      label: "Cancel",
      isAction: true,
      onPress: () => {
        props.navigation.goBack();
      },
    });
  }

  const buttonsMarkup = (
    <Stack fill>
      {buttons.map(({ key, ...button }) => (
        <View flex>
          <Button key={key} {...button} isAction={true} fullWidth></Button>
        </View>
      ))}
    </Stack>
  );

  const secondaryText = sale
    ? t("add_customer_existing_sale")
    : t("start_new_customer_sale");

  return (
    <Page
      title={"Customer found!"}
      secondaryTitle={secondaryText}
      footer={buttonsMarkup}
    >
      <CustomerCard customerId={customer.id} />
    </Page>
  );
};
